import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tab-toggle',
  templateUrl: './tab-toggle.component.html',
  styleUrls: ['./tab-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabToggleComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
